import { ArrowLeftOutlined } from '@ant-design/icons'
import Page from '@components/Page/Page'
import { NotificationContentKey } from '@models/NotificationContent'
import { SettingKey } from '@models/Setting'
import { useAppDispatch } from '@store/hooks'
import { getNotificationContents } from '@store/NotificationContentReducer'
import { getSettings } from '@store/SettingReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Permission } from '@utils/permissions'
import { Button, Col, Divider, Flex, Row } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { membershipNotificationItems } from './membershipNotificationItems'

const MembershipNotificationDetailPage = () => {
  const { notificationKey } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const item = membershipNotificationItems.find(
    (i) => i.slug === notificationKey
  )

  useEffect(() => {
    dispatch(
      getNotificationContents([
        NotificationContentKey.MEMBERSHIP_NOSHOW,
        NotificationContentKey.MEMBERSHIP_CONFIRMATION,
        NotificationContentKey.MEMBERSHIP_BIRTHDAY_NOTIFICATION,
        NotificationContentKey.MEMBERSHIP_BIRTHDAY_MODAL,
      ])
    )
    dispatch(
      getSettings([
        SettingKey.MEMBERSHIP_NOSHOW_NOTIFICATION_TIME,
        SettingKey.MEMBERSHIP_CONFIRMATION_CONFIRMATION_STATUS,
        SettingKey.MEMBERSHIP_CONFIRMATION_TIME_IN_ADVANCE,
        SettingKey.MEMBERSHIP_BIRTHDAY_NOTIFICATION_TIME,
      ])
    )
  }, [])

  if (!item) return null

  return (
    <Page permissions={Permission.manageSettingsMembershipSettings}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Flex gap={16} align="center">
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('..')}
            />
            <PageTitle
              title={item.title}
              level={4}
              style={{ margin: 0 }}
              toolbar={item.onTestClick}
            />
          </Flex>
        </Col>
        <Divider style={{ marginBottom: 10, marginTop: 5 }} />
        <Col span={24}>
          <Row gutter={[16, 16]}>{item.content}</Row>
        </Col>
      </Row>
    </Page>
  )
}

export default MembershipNotificationDetailPage
